import React from "react";
import { Table, Spin, Button, Input, Icon, Empty } from "antd";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { CdrService } from "../../services/cdr/CdrService";
import { handleError } from "../../utils/ErrorHandlers";
import Highlighter from "react-highlight-words";
import "./CDRTable.css";
import { convertTZToLocal } from "../general/DateTzHelper";
import i18next from "i18next";

class CDRSwitchedCalls extends React.Component {
  constructor(props) {
    super(props);
    this.cdrService = new CdrService();
    this.state = {
      searchText: "",
      isFetching: false,
      visible: false,
      data: [],
    };
  }

  componentDidMount() {
    this.getSwitchedCRD(
      this.props.record.cdrId,

      this.props.from,

      this.props.to
    );
  }

  async getSwitchedCRD(cdrId, from, to) {
    try {
      this.setState({ isFetching: true });

      let data = await this.cdrService.getSwitchedCRDIdService(
        this.props.context.session_id,
        cdrId,
        from,
        to
      );
      this.setState({
        data: this.formatData(data),
        isFetching: false,
      });
    } catch (e) {
      handleError(e);
    }
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={i18next.t(`Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={
            this.props.context.curr_dir === "ltr" &&
            this.props.context.curr_lang === "en"
              ? { width: 100, marginRight: 8 }
              : { width: 100, marginLeft: 8 }
          }
        >
          {i18next.t("Search")}
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 80 }}
        >
          {i18next.t("Reset")}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: "#d73a31" }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] != null &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text}
      />
    ),
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  formatData(data) {
    const updated_data = [];
    if (data.ivrList === null) {
      return [];
    }

    for (var i = 0; i < data.ivrList.length; i++) {
      var row = {};
      row["key"] = i + 1;
      row["username"] = data.ivrList[i]["username"];
      row["cdrId"] = data.ivrList[i]["cdrId"];
      row["switchTime"] = convertTZToLocal(data.ivrList[i]["switchTime"]);
      row["switchingStatus"] = data.ivrList[i]["switchingStatus"];
      row["callStatus"] = data.ivrList[i]["callStatus"];
      row["endTime"] = convertTZToLocal(data.ivrList[i]["endTime"]);
      row["answerTime"] = data.ivrList[i]["callStatus"] =="SWITCHED_REJECTED" ? "---" :convertTZToLocal(data.ivrList[i]["answerTime"]);
      updated_data.push(row);
    }
    return updated_data;
  }
  render() {
    const switchedCdrColumns = [
      { title: i18next.t("Username"), dataIndex: "username", key: "username" },
      {
        title: i18next.t("Switch Time"),
        dataIndex: "switchTime",
        key: "switchTime",
      },
      {
        title: i18next.t("Switching status"),
        dataIndex: "switchingStatus",
        key: "switchingStatus",
        ...this.getColumnSearchProps("switchingStatus"),
      },
      {
        title: i18next.t("Call status"),
        dataIndex: "callStatus",
        key: "callStatus",
        ...this.getColumnSearchProps("callStatus"),
      },
      {
        title: i18next.t("Answer Time"),
        dataIndex: "answerTime",
        key: "answerTime",
      },
      { title: i18next.t("End time"), dataIndex: "endTime", key: "endTime" },
    ];

    let { isFetching } = this.state;

    return isFetching ? (
      <Spin></Spin>
    ) : (
      <Table
        columns={switchedCdrColumns}
        dataSource={this.state.data}
        pagination={false}
        style={{ width: "99%", margin: "5px" }}
        locale={{
          emptyText: (
            <Empty
              description={i18next.t("Empty")}
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
          ),
        }}
      />
    );
  }
}

export default withSharedStateConsumer(CDRSwitchedCalls);
